export default "__VITE_ASSET__vwLVrtl7__"